import React, { useState } from 'react';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, IconButton } from '@mui/material';
import { useNotificationCenter } from 'context/NotificationCenterContext';
import { bellButtonSx } from './NotificationCenter.styles';
import NotificationPanel from './NotificationPanel';

const NotificationBell = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { notifications, unreadCount, dismissNotification } = useNotificationCenter();
  const hasInProgress = notifications.some(n => !n.dismissed && n.status === 'in_progress');

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(prev => (prev ? null : e.currentTarget));
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        data-testid="notification-bell-button"
        onClick={handleClick}
        sx={{
          ...bellButtonSx,
          ...(hasInProgress && {
            background: 'linear-gradient(135deg, #7C3AED, #4F55E7, #22D3EE)',
            borderRadius: '50%',
            color: '#fff',
            '&:hover': {
              background: 'linear-gradient(135deg, #6D28D9, #4338CA, #06B6D4)',
            },
          }),
        }}>
        <Badge
          badgeContent={unreadCount}
          color="error"
          max={99}
          invisible={unreadCount === 0}
          slotProps={{ badge: { 'data-testid': 'notification-badge' } as React.HTMLAttributes<HTMLSpanElement> }}
          sx={{ '& .MuiBadge-badge': { fontSize: '0.7rem', fontWeight: 700, minWidth: 18, height: 18 } }}>
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <NotificationPanel
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        notifications={notifications}
        onClose={handleClose}
        onDismiss={dismissNotification}
      />
    </>
  );
};

export default NotificationBell;
